import { render, staticRenderFns } from "./TrackAndTraceColumnCustom.vue?vue&type=template&id=2a1b61d6&scoped=true&"
import script from "./TrackAndTraceColumnCustom.vue?vue&type=script&lang=js&"
export * from "./TrackAndTraceColumnCustom.vue?vue&type=script&lang=js&"
import style0 from "./TrackAndTraceColumnCustom.vue?vue&type=style&index=0&id=2a1b61d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b61d6",
  null
  
)

export default component.exports